import React, {Component} from 'react'
import PrintPreview from './PrintPreview';
import PdfStore from '../../stores/PdfStore';

class PrintWorkOfficeJobTimeTable extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:false, data:[], main_tasklist:[]}

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this.loadWorkJobTimeTable()
  }

  loadWorkJobTimeTable() {
    let that = this
    let {main_tasklist} = this.state
    PdfStore.loadWorkJobOfficeTimeTableDoc(this.props.workNo,function(result) {
      if (result.data.work_state!=undefined) {
        result.data.work_state.forEach(function(item,index) {
          if (result.data.main_tasklist[index]!=undefined) {
            main_tasklist.push({
              taskName: result.data.main_tasklist[index].tasklist[0].taskName,
              first_name: result.data.main_tasklist[index].first_name,
              last_name: result.data.main_tasklist[index].last_name,
              leader_first_name: result.data.main_tasklist[index].leader_first_name,
              leader_last_name: result.data.main_tasklist[index].leader_last_name,
              startDate: result.data.main_tasklist[index].tasklist[0].startDate,
              endDate: result.data.main_tasklist[index].tasklist[0].endDate,
              startTime: result.data.main_tasklist[index].tasklist[0].startTime,
              endTime: result.data.main_tasklist[index].tasklist[0].endTime,
              taskValue: result.data.main_tasklist[index].tasklist[0].taskValue,
              remark: result.data.main_tasklist[index].remark,
            })
          } else {
            main_tasklist.push({
              taskName: item.label,
              first_name: '',
              last_name: '',
              leader_first_name: '',
              leader_last_name: '',
              startDate: '',
              endDate: '',
              startTime: '',
              endTime: '',
              taskValue: item.value,
              remark: ''
            })
          } 
        })
      }
      that.setState({data:result.data,main_tasklist:main_tasklist})
    })
  }

  renderLogoUrl(){
    let {data} = this.state
    let imgUrl = ''
    let logo_url = ''
    if (data.logo_url!=undefined) {
      logo_url = data.logo_url
      if (process.env.NODE_ENV == "development") {
        imgUrl = 'https://demo2.bigfix.co/korat/pdf/'+logo_url
      }else{
        imgUrl = '../'+logo_url
      }
      return (<img src={imgUrl} />)
    }
    return('')
  }

  renderComponentPage() {
    let {data} = this.state
    let car_registration_no = ''
    let car_color = ''
    let model = ''
    let brand = ''
    if (data.car!=undefined) {
      car_registration_no = data.car.car_registration_no
      car_color = data.car.car_color
      model = data.car.model
      brand = data.car.brand
    }
    let entrance_date = ''
    let appointment_date = ''
    if (data.receiving!=undefined) {
      entrance_date = data.receiving.entrance_date
      appointment_date = data.receiving.appointment_date
    }
    let company_name = ''
    let company_addr = ''
    let company_tel = ''
    let company_fax = ''
    if (data!=undefined) {
      company_name = data.company_name
      company_addr = data.company_addr
      company_tel = data.company_tel
      company_fax = data.company_fax
    }
    return(
      <div className='font-print'>        
        <header>
          <h2 className="text-right">{'ใบบันทึกงานภายใน'}</h2>
        </header>  
        {/*
        <article className="article-company">
          <div style={{width:'100px',textAlign:'center',lineHeight:'70px'}}>
            {this.renderLogoUrl()}
          </div>
          <section className="font-20">
            <strong>
              <p style={{lineHeight:'0.7'}}>{company_name}</p>
              <p style={{lineHeight:'0.7'}}>{company_addr}</p>
              <p style={{lineHeight:'0.7'}}>โทร {company_tel} โทรสาร {company_fax}</p>
            </strong>
          </section>
        </article>
        */}
        <div className="box-work-job-time font-18">
          <table className="table table-bordered table-work-job-time">
            <tbody>
              <tr>
                <td>ทะเบียนรถ</td>
                <td>{car_registration_no}</td>
                <td>เลขที่อ้างอิง</td>
                <td>{(this.props.workNo!=undefined?this.props.workNo:'')}</td>
              </tr>
              <tr>
                <td>วันที่เข้าซ่อม</td>
                <td>{entrance_date}</td>
                <td>ยี่ห้อ/รุ่น</td>
                <td>{brand+(brand!=''?'/':'')+model}</td>
              </tr>
              <tr>
                <td>วันที่นัดรับ</td>
                <td>{appointment_date}</td>
                <td>สี</td>
                <td>{car_color}</td>
              </tr>
            </tbody>
          </table>
          <table className="table table-bordered table-work-job-time">
            <tbody>
              <tr>
                <td className="text-center" style={{width:'120px'}}>รายการ</td>
                <td className="text-center" style={{width:'150px'}}>ชื่อพนักงาน</td>
                <td className="text-center">เวลาเริ่ม</td>
                <td className="text-center">เวลาเสร็จ</td>
                <td className="text-center">หมายเหตุ</td>
              </tr>
              {this.renderRowData()}
            </tbody>
          </table>    
          {this.renderRemark()}
        </div>
      </div>    
    )
  }
  
  renderRowData() {
    let {data,main_tasklist} = this.state
    if (data.length==0||data.ref_no=='undefined'||data.work_state==undefined) {
      return(<tr><td colSpan={5}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        main_tasklist.map((item,index) => {
          return(
            <tr key={index}>
              <td className="text-center" style={{verticalAlign:'middle'}}>{item.taskName}</td>
              <td className="text-center" style={{verticalAlign:'middle'}}>{item.first_name+' '+item.last_name}</td>
              <td className="text-center" style={{padding:'0'}}>
                <table className='table table-bordered table-sub-work-job-time'>
                  <tbody>
                    <tr>
                      <td style={{width:'50px'}} className="hr-l-none hr-t-none text-center">วันที่</td>
                      <td className="hr-r-none hr-t-none text-center">{item.startDate}</td>
                    </tr>
                    <tr>
                      <td style={{width:'50px'}} className="hr-l-none hr-b-none text-center">เวลา</td>
                      <td className="hr-r-none hr-b-none text-center">{item.startTime}</td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td className="text-center" style={{padding:'0'}}>
                <table className='table table-bordered table-sub-work-job-time'>
                  <tbody>
                    <tr>
                      <td style={{width:'50px'}} className="hr-l-none hr-t-none text-center">วันที่</td>
                      <td className="hr-r-none hr-t-none text-center">{item.endDate}</td>
                    </tr>
                    <tr>
                      <td style={{width:'50px'}} className="hr-l-none hr-b-none text-center">เวลา</td>
                      <td className="hr-r-none hr-b-none text-center">{item.endTime}</td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td className="text-center" style={{verticalAlign:'middle'}}>{item.remark}</td>
            </tr>
          )
        })
      )
    }
  }

  renderRemark() {
    return(
      <div></div> // หมายเหตุ : ช่างทุกคนต้องวันที่และเวลาทำงานจริง พร้อมส่งใบส่งงาน
    )
  }

  render() {
    let {loading} = this.state
    return(
      <PrintPreview 
        loading={loading} 
        leftBarTitle={'ใบบันทึกงานภายใน '+(this.props.workNo!=undefined?this.props.workNo:'')}>
        {this.renderComponentPage()}
      </PrintPreview>
    )
  }

}

PrintWorkOfficeJobTimeTable.defaultProps = {
  title: 'ใบบันทึกงานภายใน',  
  mode : '1'
}

export default PrintWorkOfficeJobTimeTable;


// WEBPACK FOOTER //
// ./src/view/print/PrintWorkOfficeJobTimeTable.js